import { isAxiosError } from 'axios';

/**
 * Extract a user-displayable message from an API error.
 *
 * Handles:
 *  - AxiosError with `response.data.detail` (FastAPI convention)
 *  - AxiosError with `response.data.message`
 *  - Plain Error with `.message`
 *
 * Returns `undefined` when no meaningful detail can be extracted.
 */
export function extractApiErrorDetail(error: unknown): string | undefined {
  if (isAxiosError(error)) {
    const data: unknown = error.response?.data;
    if (typeof data === 'object' && data !== null) {
      const record = data as Record<string, unknown>;
      if (typeof record.detail === 'string' && record.detail.trim() !== '') {
        return record.detail;
      }
      if (typeof record.message === 'string' && record.message.trim() !== '') {
        return record.message;
      }
    }
    if (error.response) {
      return `Server error (${String(error.response.status)})`;
    }
    if (error.code === 'ERR_NETWORK') {
      return 'Network error — please check your connection.';
    }
  }

  if (error instanceof Error && error.message.trim() !== '') {
    return error.message;
  }

  return undefined;
}
